import { render, staticRenderFns } from "./showStops-editor.vue?vue&type=template&id=7f6920d6&scoped=true&"
import script from "./showStops-editor.vue?vue&type=script&lang=js&"
export * from "./showStops-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6920d6",
  null
  
)

export default component.exports